import { Model } from '../core/base.model';

export class EmployeeJourney extends Model {
    protected static _resource = 'companyManagement/companies/:company/employees/:employee/employeeJourneys';
    protected static _version = 'v2';
    protected static _serializeAttributes = [
        'id',
        'title',
        'type',
        'message',
        'date',
        'endDate',
        'db_field',
        'old_value',
        'new_value',
        'changed_by',
        'date_changed',
    ];
    protected static _dates = ['date_changed'];

    get title(): string {
        return this._attributes['title'];
    }

    get type(): string {
        return this._attributes['type'];
    }

    get message(): string {
        return this._attributes['message'];
    }

    get date(): object | string {
        return this._attributes['date'];
    }

    get endDate(): object | string {
        return this._attributes['endDate'];
    }

    set title(val: string | null) {
        this._attributes['title'] = val;
    }

    set message(val: string | null) {
        this._attributes['message'] = val;
    }

    set date(val: object | string) {
        this._attributes['date'] = val;
    }
}
